import { toast as toastify, type Id } from "react-toastify";

/**
 * App-wide toast entry point.
 *
 * Success toasts are suppressed: after an add, edit or delete the list on
 * screen already shows the result, so the popup only added something to wait
 * out — and it sat over the action buttons while it did. Failures, warnings
 * and info still surface, because those have no other visual.
 *
 * The `toast.success(...)` calls are deliberately left in place across the app
 * rather than deleted, so turning them back on (or making them selective) is a
 * change to this file alone.
 *
 * Everything else is passed through untouched, including calling `toast(...)`
 * directly, which RequestController does via a callback.
 */
const suppressedSuccess = ((): Id => "" as Id) as typeof toastify.success;

export const toast: typeof toastify = Object.assign(
  ((content: Parameters<typeof toastify>[0], options?: Parameters<typeof toastify>[1]) =>
    toastify(content, options)) as typeof toastify,
  toastify,
  { success: suppressedSuccess }
);
